import { ClientInputError } from '@/lib/errors/client';

import { fillBatchOrder } from '@/components/TransactionModule/fillBatchOrder';

import { createEvmStrategy } from './evm';

/** Smart-wallet approval-and-swap batch strategy. */
export const batchStrategy = createEvmStrategy({
  lane: 'batch',
  transactionType: 'batch-swap',
  send: async ({ ctx, quote, client }) => {
    const allowance = quote.issues.allowance;
    if (!allowance) throw new ClientInputError('submitSwap: missing batch allowance');

    return {
      kind: 'callsId',
      value: await fillBatchOrder({
        allowance: BigInt(allowance.actual),
        transaction: quote.transaction,
        chainId: ctx.chainId,
        walletClient: client,
        connectorId: ctx.ethereumWallet?.meta.id,
        sellAmount: BigInt(quote.sellAmount),
        sellToken: ctx.sellToken,
        spender: allowance.spender,
      }),
    };
  },
});
